import { render, staticRenderFns } from "./DocumentPagination.vue?vue&type=template&id=f9edb35e&scoped=true"
import script from "./DocumentPagination.vue?vue&type=script&lang=js"
export * from "./DocumentPagination.vue?vue&type=script&lang=js"
import style0 from "./DocumentPagination.vue?vue&type=style&index=0&id=f9edb35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9edb35e",
  null
  
)

export default component.exports